import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsPreviewCalculatedFiltersCacheKey } from "./constants";
import type {
  CustomObjectsPreviewCalculatedFiltersApiProps,
  CustomObjectsPreviewCalculatedFiltersResponse,
} from "./types";

export const getCustomObjectsPreviewCalculatedFilters = reactQueryFetcherAdapter(
  customObjectsPreviewCalculatedFiltersCacheKey,
  (
    signal,
    { userIdentifier, campaignBaseId, isWorkflowStep }: CustomObjectsPreviewCalculatedFiltersApiProps
  ): Promise<CustomObjectsPreviewCalculatedFiltersResponse> => {
    return fetch<CustomObjectsPreviewCalculatedFiltersResponse>(
      `/data_objects/preview_calculated_filters/${encodeURIComponent(userIdentifier)}`,
      "GET",
      {
        campaign_base_id: campaignBaseId,
        is_workflow_step: isWorkflowStep,
      },
      { signal }
    );
  }
);
